import React from "react";
import { Instagram, Facebook, LinkedinIcon } from "lucide-react";

import logometa from "../../images/LandingPageImage/Logo-Meta.png";
import Googleplay from "../../images/LandingPageImage/googleplay.png";
import Logo from "../../images/MY-Anlook.png";
// import chaafo from "../../images/LandingPageImage/ChaafoRestaurant.webp";
// import chaafo from "../../images/LandingPageImage/Chaafo_Logo.png";
import chaafo from "../../images/LandingPageImage/chaafo-logo-footer.svg";
// import chaafo from "../../images/LandingPageImage/chaafo-logo.svg";

const Footer = () => {
  const socialLinks = {
    insta: "https://www.instagram.com/anlookofficial/",
    facebook: "https://www.facebook.com/anlookfb/",
    linkedin: "https://www.linkedin.com/company/anlook-official/",
  };

  return (
    <footer className="footer-section bg-[#165c4f] py-12 text-white sm:py-14 lg:py-16">
      <div className="mx-auto max-w-7xl px-5 sm:px-6">
        {/* 1 ROW LAYOUT */}
        <div className="flex flex-col justify-between gap-10 lg:flex-row lg:gap-12">
          {/* LEFT SIDE */}
          <div className="lg:w-[32%]">
            <a href="/get" className="inline-block">
              <img
                src={Logo}
                alt="Anlook Logo"
                className="mb-5 w-32 object-contain sm:mb-6 sm:w-36"
              />
            </a>

            <p className="max-w-xl text-sm leading-relaxed text-[#d1f0ea]">
              Anlook is a restaurant growth and automation platform managed by
              Chaafo, marketed by Bumppy Media Pvt. Ltd., built to help food
              businesses operate smarter and grow consistently.
            </p>
          </div>

          {/* COMPANY */}
          <div>
            <h6 className="mb-4 font-semibold">Company</h6>

            <ul className="space-y-2 text-sm text-[#d1f0ea]">
              <li>
                <a
                  href="/about-us"
                  className="transition hover:text-white"
                >
                  About us
                </a>
              </li>

              <li>
                <a href="/blogs" className="transition hover:text-white">
                  Blogs
                </a>
              </li>

              <li>
                <a
                  href="/contact-us"
                  className="transition hover:text-white"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* RESOURCES */}
          <div>
            <h6 className="mb-4 font-semibold">Resources</h6>

            <ul className="space-y-2 text-sm text-[#d1f0ea]">
              <li>
                <a
                  href="/privacy-policy"
                  className="transition hover:text-white"
                >
                  Privacy Policy
                </a>
              </li>

              <li>
                <a
                  href="/terms-conditions"
                  className="transition hover:text-white"
                >
                  Terms & Condition
                </a>
              </li>
            </ul>
          </div>

          {/* RIGHT SIDE */}
          <div className="flex flex-col items-start gap-5 sm:gap-6">
            {/* Chaafo and Meta Logos */}
            <div className="flex flex-wrap items-center gap-4">
              <img
                src={chaafo}
                alt="Chaafo Restaurant"
                className="h-14 w-auto max-w-[150px] rounded-lg object-contain p-1 sm:h-16 sm:max-w-[170px]"
              />

              <img
                src={logometa}
                alt="Meta Logo"
                className="h-14 w-auto max-w-[130px] object-contain sm:h-16 sm:max-w-[145px]"
              />
            </div>

            <a
              href="https://play.google.com/store/apps/details?id=com.application.anlook&hl=en_IN"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={Googleplay}
                alt="Google Play"
                className="w-36 object-contain transition hover:scale-105 sm:w-40"
              />
            </a>

            <div>
              <h6 className="mb-3 font-semibold">Follow Us</h6>

              <div className="flex flex-wrap gap-3 sm:gap-4">
                <a
                  href={socialLinks.insta}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#00d084] transition hover:bg-[#00b974]"
                >
                  <Instagram size={18} />
                </a>

                <a
                  href={socialLinks.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#00d084] transition hover:bg-[#00b974]"
                >
                  <Facebook size={18} />
                </a>

                <a
                  href={socialLinks.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#00d084] transition hover:bg-[#00b974]"
                >
                  <LinkedinIcon size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="mt-10 border-t border-white/20 pt-6 text-center text-sm leading-relaxed text-[#d1f0ea] sm:mt-12">
          Anlook © {new Date().getFullYear()}. All rights reserved. Developed,
          Marketed & Owned by Bumppy.
        </div>
      </div>
    </footer>
  );
};

export default Footer;